const allColors = [
    [
        '#F7F7F7',
        '#11A752',
    ],
    [
        '#ffffff',
        '#14a160',
    ],
    [
        '#eeeeee',
        '#ffffff',
    ],
    [
        "white",
        "#ff5937",
    ],
    [
        "white",
        "#3159ee",
    ],
    [
        "white",
        "#d94d99",
    ],
    [
        "white",
        "black",
    ],
    [
        "white",
        "red",
    ],
    [
        "white",
        "blue",
    ],
    [
        '#F7F7F7',
        '#11A752',
    ],
    [
        '#ffffff',
        '#14a160',
    ],
    [
        '#eeeeee',
        '#ffffff',
    ],
    [
        "white",
        "#ff5937",
    ],
    [
        "white",
        "#3159ee",
    ],
    [
        "white",
        "#d94d99",
    ],
    [
        "white",
        "black",
    ],
    [
        "white",
        "red",
    ],
    [
        "white",
        "blue",
    ],
    [
        '#F7F7F7',
        '#11A752',
    ],
    [
        '#ffffff',
        '#14a160',
    ],
    [
        '#eeeeee',
        '#ffffff',
    ],
    [
        "white",
        "#ff5937",
    ],
    [
        "white",
        "#3159ee",
    ],
    [
        "white",
        "#d94d99",
    ],
    [
        "black",
        "white",
    ],
    [
        "white",
        "black",
    ],
    [
        "white",
        "red",
    ],
    [
        "white",
        "blue",
    ],
    [
        "blue",
        "white",
    ],

]
export default allColors